import { ValidationMessage } from 'models';

export function validatePaymentAmount(balance, amount) {
    if (parseFloat(balance) < parseFloat(amount)) {
        return new ValidationMessage('Amount Greater than Balance', false);
    }

    return new ValidationMessage('', true);
}
